import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
  TextField,
} from "@mui/material";
import { callAPI } from "../../../App/Helpers/callApi";
import LoadingBar from "../../../App/Components/LoadingBar/LoadingBar";
import DropdownComponent from "../../../App/Components/Dropdown/DropdownComponent";
import { editTrackingPixel, getTrackingPixels } from "../TrackingPixelService";
import { TrackingPixelType } from "../../../App/Enums/TrackingPixels";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  error: {
    color: theme.palette.error.main,
  },
}));
export default function AddTrackingPixelModal({
  openModal,
  client,
  setShowSignifier,
  setResponseMessage,
  setShowError,
  setTableData,
}) {
  const classes = useStyles();
  const [processing, setProcessing] = useState(false);
  const [inputError, setInputError] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [name, setName] = useState("");
  const [endpoint, setEndpoint] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [types, setTypes] = useState([
    { name: "MiQ Universal", val: 1 },
    { name: "MiQ Landing Page", val: 2 },
    { name: "MiQ Conversion", val: 3 },
  ]);

  const checkInput = () => {
    if (name === "" || endpoint === "") {
      return false;
    }
    return true;
  };

  function addPixel() {
    if (!checkInput()) {
      setInputError(true);
      return;
    }

    let json = {
      ClientId: client.id,
      Name: name,
      Type: selectedType.val,
      Endpoint: endpoint,
      IsActive: isActive,
    };

    callAPI(
      editTrackingPixel(json),
      "Pixel Added",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getTrackingPixels(client.id).then((response) => {
        response.forEach(
          (row) =>
            (row.typeName =
              TrackingPixelType[
                Object.keys(TrackingPixelType).find(
                  (key) => TrackingPixelType[key]?.val === row.type
                )
              ].name)
        );
        setTableData(response);
        openModal(false);
      });
    });
  }

  return (
    <div className={classes.root}>
      <LoadingBar loading={processing} />
      <Grid>
        <Card>
          <CardContent>
            <FormHelperText style={{ fontWeight: "bold" }}>
              Add Tracking Pixel
            </FormHelperText>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <DropdownComponent
                  currValue={selectedType}
                  items={types}
                  property="name"
                  title="Type"
                  handleChange={(value) => setSelectedType(value)}
                />
              </Grid>
              <Grid xs={12} sm={12} item>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={isActive}
                      onChange={() => setIsActive(!isActive)}
                    />
                  }
                  label="Is Active?"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="Name"
                  label="Name"
                  variant="standard"
                  fullWidth
                  required
                  error={inputError && name === ""}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                {inputError && name === "" && (
                  <FormHelperText className={classes.error}>
                    Name Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="Endpoint"
                  label="Endpoint"
                  variant="standard"
                  fullWidth
                  required
                  error={inputError && endpoint === ""}
                  value={endpoint}
                  onChange={(e) => setEndpoint(e.target.value)}
                />
                {inputError && endpoint === "" && (
                  <FormHelperText className={classes.error}>
                    Endpoint Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid
                container
                justifyContent="flex-end"
                direction="row"
                style={{ marginRight: "10px" }}
              >
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ color: "#82B288", marginTop: "20px" }}
                    type="submit"
                    variant="outlined"
                    fullWidth
                    onClick={() => openModal(false)}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ marginTop: "20px", marginLeft: "10px" }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => addPixel()}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
